import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'fdb-reports',
  templateUrl: './reports.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent {

  constructor() { }

}
